export const jewelleryBeadsLevelThree = [
  {
    "name": "Indian Glass Seed Bead",
    "categoryId": "indian_glass_seed_bead",
    "parentCategoryName": "Glass Seed Bead",
    "parentCategoryId": "glass_seed_beads",
    "level": 3
  },
  {
    "name": "Czech Glass Seed Bead",
    "categoryId": "czech_glass_seed_bead",
    "parentCategoryName": "Glass Seed Bead",
    "parentCategoryId": "glass_seed_beads",
    "level": 3
  },
  {
    "name": "Hydro Beads",
    "categoryId": "hydro_bead",
    "parentCategoryName": "Glass Seed Bead",
    "parentCategoryId": "glass_seed_beads",
    "level": 3
  },
  {
    "name": "Rondelle Tyre Beads",
    "categoryId": "rondelle_tyre_bead",
    "parentCategoryName": "Crystal Glass Beads",
    "parentCategoryId": "crystal_glass_beads",
    "level": 3
  },
  {
    "name": "Bi-Cone Beads(Damru)",
    "categoryId": "bi-cone_beads_damru",
    "parentCategoryName": "Crystal Glass Beads",
    "parentCategoryId": "crystal_glass_beads",
    "level": 3
  },
  {
    "name": "Drop Shape Beads",
    "categoryId": "drop_shap_bead",
    "parentCategoryName": "Crystal Glass Beads",
    "parentCategoryId": "crystal_glass_beads",
    "level": 3
  },

  {
    "name": "Alphabet Beads",
    "categoryId": "alphabet_beads",
    "parentCategoryName": "Acrylic Beads",
    "parentCategoryId": "acrylic_beads",
    "level": 3
  },
  {
    "name": "Round Beads",
    "categoryId": "round_beads",
    "parentCategoryName": "Acrylic Beads",
    "parentCategoryId": "acrylic_beads",
    "level": 3
  },
  {
    "name": "Evil Eye",
    "categoryId": "evil_eye",
    "parentCategoryName": "Acrylic Beads",
    "parentCategoryId": "acrylic_beads",
    "level": 3
  },
  {
    "name": "Dotted Pearl Beads",
    "categoryId": "dotted_pearl_beads",
    "parentCategoryName": "Acrylic Beads",
    "parentCategoryId": "acrylic_beads",
    "level": 3
  },
  {
    "name": "Fancy Acrylic Beads",
    "categoryId": "fancy_acrylic_beads",
    "parentCategoryName": "Acrylic Beads",
    "parentCategoryId": "acrylic_beads",
    "level": 3
  },
  {
    "name": "Metallic Acrylic Beads",
    "categoryId": "metallic_acrylic_beads",
    "parentCategoryName": "Acrylic Beads",
    "parentCategoryId": "acrylic_beads",
    "level": 3
  },
  {
    "name": "Solid Opaque Beads",
    "categoryId": "solid_opaque_bead",
    "parentCategoryName": "Glass Beads",
    "parentCategoryId": "glass_beads",
    "level": 3
  },
  {
    "name": "Marble Beads",
    "categoryId": "marble_bead",
    "parentCategoryName": "Glass Beads",
    "parentCategoryId": "glass_beads",
    "level": 3
  },
  {
    "name": "Jelly Beads",
    "categoryId": "jelly_beads",
    "parentCategoryName": "Glass Beads",
    "parentCategoryId": "glass_beads",
    "level": 3
  },
  {
    "name": "Glass Pearl Beads",
    "categoryId": "glass_pearl_beads",
    "parentCategoryName": "Glass Beads",
    "parentCategoryId": "glass_beads",
    "level": 3
  },
  {
    "name": "Half Cut Glass Pearl",
    "categoryId": "half_cut_glass_pearl",
    "parentCategoryName": "Glass Beads",
    "parentCategoryId": "glass_beads",
    "level": 3
  },
  {
    "name": "Crackle Beads",
    "categoryId": "crackle_beads",
    "parentCategoryName": "Glass Beads",
    "parentCategoryId": "glass_beads",
    "level": 3
  },
  {
    "name": "Glass Evil Eye Beads",
    "categoryId": "glass_evil_eye_beads",
    "parentCategoryName": "Glass Beads",
    "parentCategoryId": "glass_beads",
    "level": 3
  },
  {
    "name": "Freshwater",
    "categoryId": "freshwater",
    "parentCategoryName": "Real Pearl & Cowrie",
    "parentCategoryId": "real_pearl_n_cowrie",
    "level": 3
  },
  {
    "name": "Cowrie",
    "categoryId": "Cowrie",
    "parentCategoryName": "Real Pearl & Cowrie",
    "parentCategoryId": "real_pearl_n_cowrie",
    "level": 3
  },
  {
    "name": "Chip Beads",
    "categoryId": "chip_beads",
    "parentCategoryName": "Semi Precious Beads",
    "parentCategoryId": "semi_precious_beads",
    "level": 3
  },
  {
    "name": "Lava Beads",
    "categoryId": "lava_beads",
    "parentCategoryName": "Semi Precious Beads",
    "parentCategoryId": "semi_precious_beads",
    "level": 3
  },
  {
    "name": "Aura Quartz Beads",
    "categoryId": "aura_quartz_beads",
    "parentCategoryName": "Semi Precious Beads",
    "parentCategoryId": "semi_precious_beads",
    "level": 3
  },
  {
    "name": "Cheveron Beads",
    "categoryId": "cheveron_beads",
    "parentCategoryName": "Semi Precious Beads",
    "parentCategoryId": "semi_precious_beads",
    "level": 3
  },
  {
    "name": "Lampwork Beads",
    "categoryId": "lampwork_beads",
    "parentCategoryName": "Semi Precious Beads",
    "parentCategoryId": "semi_precious_beads",
    "level": 3
  },
  {
    "name": "Fimo Beads",
    "categoryId": "fimo_beads",
    "parentCategoryName": "Other Beads",
    "parentCategoryId": "other_beads",
    "level": 3
  },
  {
    "name": "Japanese Beads",
    "categoryId": "japanese_beads",
    "parentCategoryName": "Other Beads",
    "parentCategoryId": "other_beads",
    "level": 3
  },
  {
    "name": "Wooden Beads",
    "categoryId": "wooden_beads",
    "parentCategoryName": "Other Beads",
    "parentCategoryId": "other_beads",
    "level": 3
  },

]

